<template>
    <section id="form-create">
        <form class="form" @submit.prevent="onSubmit">
        <div class="field">
            <label class="label">Inspected On</label>
            <div class="control">
                <input class="input" type="text" placeholder="Text input">
            </div>
        </div>
        <div class="field">
            <label class="label">Inspected By</label>
            <div class="control">
                <input class="input" type="text" placeholder="Text input">
            </div>
        </div>
        <div class="field">
            <label class="label">Pond name</label>
            <div class="control">
                <input class="input" type="text" placeholder="Text input">
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label class="label">Pond Access</label>
                <div class="select">
                    <select>
                        <option>Clear</option>
                        <option>Require Maintenance</option>
                        <option>Blocked</option>
                    </select>
                </div>
            </div>
        </div>
        <div class="field">
            <div class="columns">
                <div class="column">
                    <label class="label">Weed Coverage</label>
                    <b-field>
                        <b-select expanded v-model="weedCoverage">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in percentageOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <label class="label">Weed Type</label>
                    <b-field>
                        <b-select expanded v-model="weedType">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in weedTypes">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>            
            </div>
            <div class="columns">
                <div class="column">
                    <label class="label">Inlet (% blocked)</label>
                    <b-field>
                        <b-select expanded v-model="weedCoverage">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in percentageOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <label class="label">Inlet Cleared</label>
                    <b-field>
                        <b-select expanded v-model="weedType">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in inletClearedOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>            
            </div>
            <div class="columns">
                <div class="column">
                    <label class="label">Outlet (% blocked)</label>
                    <b-field>
                        <b-select expanded v-model="weedCoverage">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in percentageOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <label class="label">Outlet Cleared</label>
                    <b-field>
                        <b-select expanded v-model="weedType">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in outletClearedOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>            
            </div>
            <div class="columns">
                <div class="column">
                    <label class="label">Spillway Cleared</label>
                    <b-field>
                        <b-select expanded v-model="spillway">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in spillwayClearedOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>
                <div class="column">
                    <label class="label">General Condition</label>
                    <b-field>
                        <b-select expanded v-model="generalCondition">
                            <option 
                                :key="option.value"
                                :value="option.value"                    
                                v-for="option in generalConditionOptions">{{option.text}}</option>
                        </b-select>
                    </b-field>
                </div>            
            </div>                        
        </div>
        <div class="field">
            <label class="label" for="fileUpload">Upload a file</label>
            <b-field class="file">
                <b-upload v-model="files" id="fileUpload">
                    <a class="button is-info">
                        <b-icon icon="upload"></b-icon>
                        <span>Click to upload</span>
                    </a>
                </b-upload>
                <span class="file-name"
                    v-if="files && files.length">
                    {{ files[0].name }}
                </span>
            </b-field>            
        </div>
        <div class="field">
            <div class="control">
                <label for="engrComment" class="label">Engineer Comments</label>
                <textarea id="engrComment" rows="5" class="textarea"></textarea>
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label for="generalComment" class="label">General Comments</label>
                <textarea id="generalComment" rows="5" class="textarea"></textarea>
            </div>
        </div>
        <div class="field">
            <div class="control">
                <label for="notes" class="label">Notes</label>
                <textarea id="notes" rows="5" class="textarea"></textarea>
            </div>
        </div>        
        <div class="field is-grouped">
            <div class="control">
                <button class="button is-link">Submit</button>
            </div>
            <div class="control">
                <button @click="goto('/forms')" class="button is-text">Cancel</button>
            </div>
        </div>
        </form>
    </section>
</template>
<script>

import { Percentage } from '@/helpers/percentage-options';
import { Cleared } from '@/helpers/cleared-options';
import { YesNo } from '@/helpers/yes-no-options';
import { GeneralCondition } from '@/helpers/general-condition-options';

export default {
    name: 'form-create',
    data() {
        return {
            weedCoverage: '0',
            weedType: 'na',
            spillway: 'yes',
            generalCondition: 'tidy',
            percentageOptions: Percentage.options(),
            weedTypes: [
                {
                    value: 'na',
                    text: 'N/A'
                },
                {
                    value: 'oxygen_weed',
                    text: 'Oxygen Weed'
                },
                {
                    value: 'raupo',
                    text: 'Raupo'
                },
                            {
                    value: 'other',
                    text: 'Others'
                }                        
            ],
            inletClearedOptions: Cleared.options(),
            outletClearedOptions: Cleared.options(),
            spillwayClearedOptions: YesNo.options(),
            generalConditionOptions: GeneralCondition.options(),
            files: []
        }
    },
    methods: {
        goto(url) {
            this.$router.replace(url);
        }
    }
}
</script>




// WEBPACK FOOTER //
// src/components/pages/Forms/create/index.vue